import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import i18next from 'i18next';
import PropTypes from 'prop-types';

import { addressPropTypes } from '~propTypes/address';
import SectionTitle from '~components/SectionTitle';
import LocalStorageService from '~services/LocalStorageService';
import { actionCreators as searchStoreActions } from '~redux/SearchStore/actions';

import Address from '../Address';
import styles from '../../styles.module.scss';
import { ICON_ADDRESS } from '../../constants';

const UserAddresses = ({ onAddressSelect, selectedAddress }) => {
  const dispatch = useDispatch();
  const userAddresses = useSelector((state) => state.searchStore.userAddresses);
  const accessToken = LocalStorageService.getAccessToken();
  const history = useHistory();

  useEffect(() => {
    if (accessToken) {
      dispatch(searchStoreActions.getUserAddress());
    }
  }, [dispatch, history, accessToken]);
  return (
    <>
      {userAddresses && userAddresses.length > 0 && (
        <div>
          <SectionTitle
            titleClassName={`text-base ${styles.subtitleForm}`}
            className={`${styles.subtitleForm} m-top-2`}
            noSeparator
            tag="h4">
            {i18next.t('DeliveryOrPickup:myAddresses')}
          </SectionTitle>
          <div className={`row wrap item-1 ${styles.addressGroup}`}>
            {userAddresses.map((address) => (
              <Address
                className={styles.buttonAddress}
                key={address.id}
                data={address}
                icon={ICON_ADDRESS[address?.kind]}
                onClick={onAddressSelect}
                selectedAddressId={selectedAddress?.id}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

UserAddresses.propTypes = {
  selectedAddress: addressPropTypes,
  onAddressSelect: PropTypes.func
};

export default UserAddresses;
